<template>
  <div class="summary">
    <div class="summary-title">
      OKR {{ tm('summary') }}
    </div>
    <a-row :gutter="[16, 16]">
      <a-col
        :md="24"
        :lg="12"
      >
        <StatisticsCard
          :is-loading="isLoading"
          :title="tm('fillingStatus')"
          :percent-title="tm('fillingRate')"
          :percent="$filters.getRate(filledInCount, totalCount)"
          :from="color.filledIn.from"
          :to="color.filledIn.to"
          class="summary-body__item"
        >
          <div class="statistics-text">
            <p>{{ tm('publishedNum') }}：{{ publishedCount }}</p>
            <p>{{ tm('unpublishedNum') }}：{{ unpublishCount }}</p>
            <p>{{ tm('staffNum') }}：{{ totalCount }}</p>
          </div>
        </StatisticsCard>
      </a-col>
      <a-col
        :md="24"
        :lg="12"
      >
        <StatisticsCard
          :is-loading="isLoading"
          :title="tm('alignStatus')"
          :percent-title="tm('alignRate')"
          :percent="$filters.getRate(alignedCount, publishedCount)"
          :from="color.aligned.from"
          :to="color.aligned.to"
          class="summary-body__item"
        >
          <div class="statistics-text">
            <p>{{ tm('alignedNum') }}：{{ alignedCount }}</p>
            <p>{{ tm('publishedNum') }}：{{ publishedCount }}</p>
          </div>
        </StatisticsCard>
      </a-col>
      <a-col
        :md="24"
        :lg="12"
      >
        <StatisticsCard
          :is-loading="isLoading"
          :title="tm('updateStatus')"
          :percent-title="tm('updateRate')"
          :percent="$filters.getRate(updatedCount, publishedCount)"
          :from="color.updated.from"
          :to="color.updated.to"
          class="summary-body__item"
        >
          <div class="statistics-text">
            <p>{{ tm('updatedNum') }}：{{ updatedCount }}</p>
            <p>{{ tm('publishedNum') }}：{{ publishedCount }}</p>
          </div>
        </StatisticsCard>
      </a-col>
      <a-col
        :md="24"
        :lg="12"
      >
        <StatisticsCard
          :is-loading="isLoading"
          :title="tm('reviewStatus')"
          :percent-title="tm('reviewRate')"
          :percent="$filters.getRate(reviewedCount, publishedCount)"
          :from="color.reviewed.from"
          :to="color.reviewed.to"
          class="summary-body__item"
        >
          <div class="statistics-text">
            <p>{{ tm('reviewedNum') }}：{{ reviewedCount }}</p>
            <p>{{ tm('publishedNum') }}：{{ publishedCount }}</p>
          </div>
        </StatisticsCard>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import * as color from '@/constants/statistic-color'
import { getSummary as getSummaryApi } from '@/graphql/statistic'
import StatisticsCard from '@/components/StatisticsCard'

export default defineComponent({
  name: 'Summary',
  components: {
    StatisticsCard
  },
  props: {
    departmentIds: {
      type: Array,
      required: true
    }
  },
  setup (props) {
    const { state } = useStore()
    const { tm } = useI18n()
    const cycleId = computed(() => state.selectedCycleId)
    const isLoading = ref(false)
    const totalCount = ref(0)
    const filledInCount = ref(0)
    const publishedCount = ref(0)
    const alignedCount = ref(0)
    const unpublishCount = computed(() => filledInCount.value - publishedCount.value)
    const updatedCount = ref(0)
    const reviewedCount = ref(0)

    function getSummary () {
      if (cycleId.value === null || props.departmentIds.length === 0) {
        return
      }
      isLoading.value = true
      getSummaryApi(cycleId.value, props.departmentIds)
        .then(res => {
          totalCount.value = res.totalCount
          filledInCount.value = res.filledInCount
          publishedCount.value = res.publishedCount
          alignedCount.value = res.alignedCount
          updatedCount.value = res.updatedCount
          reviewedCount.value = res.reviewedCount
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    getSummary()

    watch([
      cycleId,
      () => props.departmentIds
    ], getSummary)

    return {
      isLoading,
      totalCount,
      filledInCount,
      publishedCount,
      alignedCount,
      unpublishCount,
      updatedCount,
      reviewedCount,
      color,
      tm (name) {
        return tm('statistic.overview.' + name)
      }
    }
  }
})
</script>

<style lang="less" scoped>
.summary {
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 6px 0 rgba(39, 52, 125, 0.08);
}

.summary-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

.statistics-text {
  p {
    margin-bottom: 4px;
  }
}
</style>
